"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Processing = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _Processing = require("./Processing.styled");
var _constant = require("../constant");
var Processing = exports.Processing = function Processing(props) {
  var tooltipText = props.tooltipText,
    tooltipStyle = props.tooltipStyle,
    tooltipWidth = props.tooltipWidth,
    theme = props.theme;
  if (!tooltipText) return null;
  var title = "PROCESSING";
  return /*#__PURE__*/_react["default"].createElement(_Processing.StyledWrapper, {
    $theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_Processing.StyledSpinner, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
    size: "sm"
  })), /*#__PURE__*/_react["default"].createElement(_Processing.StyledStatusText, null, title), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Processing.StyledInfoIcon, {
    id: title
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faInfoCircle,
    style: {
      color: "#8489A4"
    }
  })), /*#__PURE__*/_react["default"].createElement(_Processing.StyledTooltip, {
    id: "".concat(title, "_tooltip"),
    placement: "top",
    style: tooltipStyle,
    target: _constant.PROCESSING,
    $tooltipWidth: tooltipWidth,
    $theme: theme
  }, tooltipText)));
};
Processing.defaultProps = {
  tooltipWidth: 250,
  tooltipStyle: {},
  theme: _constant.DARK
};
Processing.propTypes = {
  tooltipText: _propTypes.string.isRequired,
  tooltipStyle: (0, _propTypes.shape)({
    backgroundColor: _propTypes.string,
    color: _propTypes.string
  }),
  tooltipWidth: _propTypes.number,
  theme: (0, _propTypes.oneOf)([_constant.DARK, _constant.LIGHT])
};